import Platform from '@/types/Platform'

export default Platform.fromStorable({
	id: 'e-k-v2',
	settings: {
		logo: require('@/assets/logo-kleinanzeigen.png'),
		name: 'Kleinanzeigen',
		format: {
			width: 2500,
			height: 1875
		},
		maxCount: 20,
		defaultOverlays: [
			{ name: 'WatermarkAnnotationBottomLeft', args: [true] }
		],
		setRules: {
			'0': [
				{
					category: ['special', 'title'],
					allowFullPicture: true,
					padding: {
						top: 0.3,
						bottom: 0.3
					},
					overlays: [
						{ name: 'WatermarkAnnotationBottomLeft' },
						{ name: 'BrandLogoAnnotation' }
					]
				}
			]
		},
		rules: [
			[
				{
					category: ['special', 'title'],
					allowFullPicture: true,
					padding: {
						top: 0.2,
						bottom: 0.2
					},
					overlays: [
						{ name: 'WatermarkAnnotationBottomLeft' },
						{ name: 'BrandLogoAnnotation' }
					]
				}
			],
			[
				{
					category: ['special', 'measurements'],
					allowFullPicture: true,
					padding: {
						top: 0.24,
						bottom: 0.31
					},
					overlays: [
						{ name: 'BrandLogoAnnotation' },
						{ name: 'MeasurementAnnotation', args: [true] }
					]
				}
			],
			[
				{
					category: ['functions', null],
					allowFullPicture: true,
					allowFindNext: true,
					padding: {
						top: 0.2,
						bottom: 0.2
					},
					overlays: [
						{ name: 'WatermarkAnnotationBottomLeft', args: [true] }
					]
				}
			],
			[
				{
					category: ['functions', null],
					allowFullPicture: true,
					allowFindNext: true,
					padding: {
						top: 0.2,
						bottom: 0.2
					},
					overlays: [
						{ name: 'WatermarkAnnotationBottomLeft', args: [true] }
					]
				}
			],
			[
				{
					category: ['functions', null],
					allowFullPicture: true,
					allowFindNext: true,
					padding: {
						top: 0.2,
						bottom: 0.2
					},
					overlays: [
						{ name: 'WatermarkAnnotationBottomLeft', args: [true] }
					]
				}
			],
			[
				{
					category: ['functions', null],
					allowFullPicture: true,
					allowFindNext: true,
					padding: {
						top: 0.2,
						bottom: 0.2
					},
					overlays: [
						{ name: 'WatermarkAnnotationBottomLeft', args: [true] }
					]
				}
			],
			[
				{
					category: ['special', 'materialDetail'],
					allowFullPicture: true,
					overlays: [
						{ name: 'WatermarkAnnotationBottomLeft', args: [true] }
					]
				}
			],
			[
				{
					category: ['detail', null],
					allowFullPicture: true,
					allowFindNext: true,
					overlays: [
						{ name: 'WatermarkAnnotationBottomLeft', args: [true] }
					]
				}
			],
			[
				{
					category: ['detail', null],
					allowFullPicture: true,
					allowFindNext: true,
					overlays: [
						{ name: 'WatermarkAnnotationBottomLeft', args: [true] }
					]
				}
			],
			[
				{
					category: ['detail', null],
					allowFullPicture: true,
					allowFindNext: true,
					overlays: [
						{ name: 'WatermarkAnnotationBottomLeft', args: [true] }
					]
				}
			],
			[
				{
					category: ['detail', 'damages'],
					allowFullPicture: true,
					allowFindNext: true,
					overlays: [
						{ name: 'WatermarkAnnotationBottomLeft', args: [true] }
					]
				}
			],
			[
				{
					category: ['detail', 'damages'],
					allowFullPicture: true,
					allowFindNext: true,
					overlays: [
						{ name: 'WatermarkAnnotationBottomLeft', args: [true] }
					]
				}
			],
			[
				{
					category: ['detail', 'damages'],
					allowFullPicture: true,
					allowFindNext: true,
					overlays: [
						{ name: 'WatermarkAnnotationBottomLeft', args: [true] }
					]
				}
			],
			[
				{
					category: ['special', 'colors'],
					allowFullPicture: true,
					overlays: [
						{ name: 'WatermarkAnnotationBottomLeft', args: [true] }
					]
				}
			],
			[
				{
					category: ['special', 'logo'],
					allowFullPicture: true,
					overlays: [
						{ name: 'WatermarkAnnotationBottomLeft', args: [true] }
					]
				}
			]
		],
		fillRule: [
			{
				category: ['alternate', null],
				allowFullPicture: true,
				padding: {
					top: 0.2,
					bottom: 0.2
				},
				overlays: [
					{ name: 'WatermarkAnnotationBottomLeft', args: [true] }
				]
			}
		]
	}
})
